module.exports = __webpack_public_path__ + "media/images/xlsx-8726da715b201cec586b45505b02352a.svg";